import { Customer } from '../types';
import { faker } from '@faker-js/faker';

// Indian states list for realistic Place of Supply
const indianStates = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Jammu & Kashmir', 'Delhi', 'Puducherry'
];

export const generateRandomCustomer = (state?: string): Customer => {
  // Use Faker for all customer data
  const street = faker.location.streetAddress();
  const city = faker.location.city();
  const customerState = state || indianStates[Math.floor(Math.random() * indianStates.length)];
  const pincode = faker.location.zipCode('######');
  const address = `${street}, ${city}, ${customerState}`;
  
  return {
    name: faker.person.fullName(),
    address: address,
    pincode: pincode,
    phone: `+91 ${faker.string.numeric(10)}`,
    state: customerState
  };
};

export const generateOrderNumber = (): string => {
  // Generate 17-digit order number
  const timestamp = Date.now().toString(); // 13 digits
  const random = Math.floor(Math.random() * 10000); // 4 more digits
  return `${timestamp}${random.toString().padStart(4, '0')}`; // Total 17 digits
};

export const generateInvoiceNumber = (): string => {
  const prefix = 'INV';
  const date = new Date();
  const year = date.getFullYear().toString().slice(-2);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const random = Math.floor(Math.random() * 10000);
  return `${prefix}${year}${month}${random.toString().padStart(4, '0')}`;
};

export const generateTrackingNumber = (): string => {
  return Date.now().toString() + Math.floor(Math.random() * 10000).toString().padStart(4, '0');
};

export const generateReturnCode = (): string => {
  const part1 = Math.floor(Math.random() * 900000 + 100000); // 6 digits
  const part2 = Math.floor(Math.random() * 9000000 + 1000000); // 7 digits
  return `${part1},${part2}`;
};

export const formatDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

export const calculateTotals = (price: number, quantity: number, gstRate: number, discount: number = 0) => {
  const grossAmount = price * quantity;
  const discountAmount = (grossAmount * discount) / 100;
  const taxableValue = grossAmount - discountAmount;
  const gstAmount = (taxableValue * gstRate) / 100;
  const total = taxableValue + gstAmount;
  
  return {
    grossAmount,
    discountAmount,
    taxableValue,
    gstAmount,
    total
  };
};